import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_MERCADERIA_FUMIGADA } from '../../../../config/tables'

function LiquidacionMercaderiaFumigadaView () {
  return (
    <MuiTable id={TABLA_MERCADERIA_FUMIGADA} />
  )
}

export default LiquidacionMercaderiaFumigadaView
